__turbopack_context__.v({
  "root": "LoginButton-module-scss-module__VlANyG__root",
});
